import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';
import ability from '../permissions/ability';

Vue.use(abilitiesPlugin, ability);
